import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';
import { InfoBoxType } from './types';

export const root: SxStyleFunc<InfoBoxType> = (type) => ({
  display: 'flex',
  alignItems: 'center',
  // marginLeft: 1,
  gap: (p) => p.spacing(0.5),
  width: '100%',
  color: (p) => {
    if (type === 'pending-invite') {
      return p.palette.warning[600];
    }
    if (type === 'pending-transfer-ownership') {
      return p.palette.primary[500];
    }
    return '';
  },
});

export const icon: SxStyleFunc<InfoBoxType> = (type) => ({
  color: (p) => {
    if (type === 'pending-invite') {
      return p.palette.warning[600];
    }
    if (type === 'pending-transfer-ownership') {
      return p.palette.primary[500];
    }
    return '';
  },
});

export const text: SxStyle = {
  textWrap: 'wrap',
  overflow: 'visible',
  display: 'table',
};
